<section class="integrations-section">
  <h2 class="integrations-section__title">Company integrations</h2>
  <div
    class="integrations-list"
    rvSpinner="integrations-company-section"
    [rvShowSpinner]="loading() || actionLoading()"
    [attr.aria-busy]="
      initialLoading() || loading() || actionLoading() ? 'true' : null
    "
  >
    @if (initialLoading()) {
      <div
        class="integration-connected-row-skeleton"
        role="status"
        aria-label="Loading integrations"
      >
        @for (row of [1, 2, 3]; track row) {
          <div
            class="integration-connected-row-skeleton__row"
            aria-hidden="true"
          >
            <div class="integration-connected-row-skeleton__info">
              <rv-skeleton
                class="integration-connected-row-skeleton__logo"
                [height]="52"
              />
              <div class="integration-connected-row-skeleton__text">
                <rv-skeleton
                  class="integration-connected-row-skeleton__name"
                  [height]="20"
                />
                <rv-skeleton
                  class="integration-connected-row-skeleton__username"
                  [height]="20"
                />
              </div>
            </div>
            <div class="integration-connected-row-skeleton__actions">
              <div class="integration-connected-row-skeleton__actions-desktop">
                <rv-skeleton
                  class="integration-connected-row-skeleton__button"
                  [height]="40"
                />
                <rv-skeleton
                  class="integration-connected-row-skeleton__button"
                  [height]="40"
                />
              </div>
              <div class="integration-connected-row-skeleton__actions-mobile">
                <rv-skeleton
                  class="integration-connected-row-skeleton__icon-button"
                  [height]="32"
                />
              </div>
            </div>
          </div>
        }
      </div>
    } @else if (integrations().length) {
      @for (integration of integrations(); track integration.id) {
        <integration-connected-row
          [integration]="integration"
          scope="company"
          (manage)="onManage($event)"
          (disconnect)="onDisconnect($event)"
        ></integration-connected-row>
      }
    } @else {
      <div class="integrations-empty">
        <p class="integrations-empty__title">You have no integrations</p>
        <p class="integrations-empty__subtitle">
          Connect integrations below to get started.
        </p>
      </div>
    }
  </div>
</section>
